export const WEBSITE  = {
    DOMAIN: 'www.internationalreadersllc.com'
}